var map = {
	"./404.svg": 461,
	"./ai_icon.svg": 483,
	"./ai_icon_hover.svg": 7156,
	"./app-store.svg": 214,
	"./apple.svg": 8246,
	"./arrow_down.svg": 5660,
	"./arrow_next.svg": 3510,
	"./asterisk_icon.svg": 4653,
	"./asterisk_icon_hover.svg": 1880,
	"./back_pattern.svg": 222,
	"./back_pattern2.svg": 985,
	"./background_pattern.svg": 6081,
	"./books.svg": 417,
	"./chevron_down.svg": 2145,
	"./chevron_right.svg": 1740,
	"./close-icon.svg": 4402,
	"./cursor.svg": 7592,
	"./data_text.svg": 1904,
	"./devices-icon.svg": 5776,
	"./devices-icon_hover.svg": 6383,
	"./dots.svg": 5696,
	"./dots_around_card.svg": 1774,
	"./dots_around_card_vertical.svg": 3999,
	"./dots_back.svg": 3199,
	"./dots_gray_vertical.svg": 9774,
	"./envelope.svg": 2295,
	"./flags/EN.svg": 1314,
	"./flags/IE.svg": 8130,
	"./flags/RU.svg": 7662,
	"./flags/UA.svg": 5588,
	"./flags/UK.svg": 2388,
	"./flags/US.svg": 6568,
	"./google-play.svg": 4638,
	"./google.svg": 5075,
	"./hdots.svg": 1682,
	"./hoverme-icon.svg": 1088,
	"./link-out-white.svg": 8100,
	"./link-out.svg": 5872,
	"./logo.svg": 5222,
	"./menu-icon.svg": 5185,
	"./partners/garmin-connect.svg": 5537,
	"./partners/huawei.svg": 7453,
	"./partners/mi-fit.svg": 9717,
	"./partners/mi-home.svg": 85,
	"./partners/pedometer.svg": 5361,
	"./partners/samsung-health.svg": 8064,
	"./rating-star.svg": 7753,
	"./scroll_icon.svg": 7416,
	"./star-disabled.svg": 1620,
	"./star.svg": 6410,
	"./uk_flag.svg": 4713,
	"./waves.svg": 2410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7234;